/**
 * Zwraca zmienne kluczowe do użycia w trybie porównania lub standardowym
 * @param {Array} common_key_variables - Zmienne wspólne z mapowaniem edition1 -> edition2
 * @param {Array} keyVariables - Standardowe zmienne kluczowe
 * @param {boolean} isCompareMode - Czy jesteśmy w trybie porównania
 * @returns {Array} - Tablica zmiennych do użycia
 */
export function getKeyVariablesToUse(common_key_variables, keyVariables, isCompareMode) {
   if (isCompareMode) {
      // W trybie porównania używamy common_key_variables jeśli dostępne, w przeciwnym razie keyVariables
      return (common_key_variables && common_key_variables.length > 0) ? common_key_variables : keyVariables;
   }
   return keyVariables;
}
